
import {  Computer, Home,  LayoutPanelTop,  ReceiptPoundSterling ,BookUp2,AlignVerticalDistributeCenter} from "lucide-react";

import { iconsImgs } from "../../utils/images";
export const navigationLinks = [
  { id: 1, title: "Dashboard", image:iconsImgs.home, path: "/dashboard" },
  { id: 2, title: "Company", image:iconsImgs.user, path: "/company" },

];
export const navigationLink = [
  { id: 1, title: "Dashboard", image: Home, path: "/dashboard" },

  {
    id: 2,
    title: "Company",
    image: Computer,
    path: "/company",
  },

];